import { configureStore } from '@reduxjs/toolkit';
import { setAutoFreeze } from 'immer';

import albumsReducer from 'features/albums/albumsSlice';
import dvdsReducer from 'features/dvds/dvdsSlice';
import songsReducer from 'features/songs/songsSlice';
import peopleReducer from 'features/people/peopleSlice';
import awardsReducer from 'features/awards/awardsSlice';
import toursReducer from 'features/tours/toursSlice';
import statisticsReducer from 'features/statistics/statisticsSlice';
import historyReducer from 'features/history/historySlice';

setAutoFreeze(false);

const store = configureStore({
  reducer: {
    albums: albumsReducer,
    dvds: dvdsReducer,
    songs: songsReducer,
    people: peopleReducer,
    awards: awardsReducer,
    tours: toursReducer,
    statistics: statisticsReducer,
    history: historyReducer
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    immutableCheck: false,
    serializableCheck: false
  })
});

export default store;
